var _linearGradient, _path, _linearGradient2, _path2, _linearGradient3, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgStripeClimate = function SvgStripeClimate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, props), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "stripe-climate_svg__a",
    gradientUnits: "userSpaceOnUse",
    x1: 16,
    y1: 20.629,
    x2: 16,
    y2: 7.839,
    gradientTransform: "matrix(1 0 0 -1 0 34)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00d924"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00cb1b"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.82h32c0 8.84-7.16 16-16 16s-16-7.16-16-16z",
    fill: "url(#stripe-climate_svg__a)"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "stripe-climate_svg__b",
    gradientUnits: "userSpaceOnUse",
    x1: 24,
    y1: 28.629,
    x2: 24,
    y2: 17.244,
    gradientTransform: "matrix(1 0 0 -1 0 34)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.156,
    stopColor: "#009c00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00be20"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 10.82c0 2.21-1.49 4.65-5.41 4.65-3.42 0-7.27-2.37-10.59-4.65 3.52-2.43 7.39-5.63 10.59-5.63C29.86 5.18 32 8.17 32 10.82z",
    fill: "url(#stripe-climate_svg__b)"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "stripe-climate_svg__c",
    gradientUnits: "userSpaceOnUse",
    x1: 8,
    y1: 16.749,
    x2: 8,
    y2: 29.124,
    gradientTransform: "matrix(1 0 0 -1 0 34)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe37d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc900"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.82c0 2.21 1.49 4.65 5.41 4.65 3.42 0 7.27-2.37 10.59-4.65-3.52-2.43-7.39-5.64-10.59-5.64C2.14 5.18 0 8.17 0 10.82z",
    fill: "url(#stripe-climate_svg__c)"
  })));
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiI+PGxpbmVhckdyYWRpZW50IGlkPSJhIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeDE9IjE2IiB5MT0iMjAuNjI5IiB4Mj0iMTYiIHkyPSI3LjgzOSIgZ3JhZGllbnRUcmFuc2Zvcm09Im1hdHJpeCgxIDAgMCAtMSAwIDM0KSI+PHN0b3Agb2Zmc2V0PSIwIiBzdG9wLWNvbG9yPSIjMDBkOTI0Ii8+PHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjMDBjYjFiIi8+PC9saW5lYXJHcmFkaWVudD48cGF0aCBkPSJNMCAxMC44MmgzMmMwIDguODQtNy4xNiAxNi0xNiAxNnMtMTYtNy4xNi0xNi0xNnoiIGZpbGw9InVybCgjYSkiLz48bGluZWFyR3JhZGllbnQgaWQ9ImIiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIiB4MT0iMjQiIHkxPSIyOC42MjkiIHgyPSIyNCIgeTI9IjE3LjI0NCIgZ3JhZGllbnRUcmFuc2Zvcm09Im1hdHJpeCgxIDAgMCAtMSAwIDM0KSI+PHN0b3Agb2Zmc2V0PSIuMTU2IiBzdG9wLWNvbG9yPSIjMDA5YzAwIi8+PHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjMDBiZTIwIi8+PC9saW5lYXJHcmFkaWVudD48cGF0aCBkPSJNMzIgMTAuODJjMCAyLjIxLTEuNDkgNC42NS01LjQxIDQuNjUtMy40MiAwLTcuMjctMi4zNy0xMC41OS00LjY1IDMuNTItMi40MyA3LjM5LTUuNjMgMTAuNTktNS42M0MyOS44NiA1LjE4IDMyIDguMTcgMzIgMTAuODJ6IiBmaWxsPSJ1cmwoI2IpIi8+PGxpbmVhckdyYWRpZW50IGlkPSJjIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeDE9IjgiIHkxPSIxNi43NDkiIHgyPSI4IiB5Mj0iMjkuMTI0IiBncmFkaWVudFRyYW5zZm9ybT0ibWF0cml4KDEgMCAwIC0xIDAgMzQpIj48c3RvcCBvZmZzZXQ9IjAiIHN0b3AtY29sb3I9IiNmZmUzN2QiLz48c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiNmZmM5MDAiLz48L2xpbmVhckdyYWRpZW50PjxwYXRoIGQ9Ik0wIDEwLjgyYzAgMi4yMSAxLjQ5IDQuNjUgNS40MSA0LjY1IDMuNDIgMCA3LjI3LTIuMzcgMTAuNTktNC42NS0zLjUyLTIuNDMtNy4zOS01LjY0LTEwLjU5LTUuNjRDMi4xNCA1LjE4IDAgOC4xNyAwIDEwLjgyeiIgZmlsbD0idXJsKCNjKSIvPjwvc3ZnPg==";
export { SvgStripeClimate as ReactComponent };